import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Container as BaseContainer } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { hiddenDown, hiddenUp } from '@/theme';

import { Typography } from '../Typography';

export const Container = styled(BaseContainer)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      padding: 0;
    }
  `}
`;

export const Wrapper = styled(Flex)`
  ${({ theme }) => css`
    
    ${theme.media.md.up} {
      background-color: ${theme.colors.lightGrey};
      padding: ${theme.spacing(2)} 0 ${theme.spacing(4)}};
    }
  `}
`;

export const Name = styled.h1`
  font-weight: bold;
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.primaryBlue};
    font-size: ${theme.fontSizes.h2};
    font-family: ${theme.fontFamilies.italianPlate};
    padding-bottom: ${theme.spacing(1)};
  `};
`;

export const PromotedName = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`;

export const Description = styled(Box)<{ withBorderBottom?: boolean }>`
  line-height: 22px;

  ${({ theme }) => css`
    margin: ${theme.spacing(4, 0, 0, 0)};
    font-size: ${theme.fontSizes.p2};

    ${theme.media.md.up} {
      margin: ${theme.spacing(0, 0, 2, 0)};
      padding-bottom: 0;
    }
  `}
`;

export const Sku = styled.p`
  text-transform: uppercase;

  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(2)};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p3};
    color: ${({ theme }) => theme.colors.black};
  `}
`;

export const Divider = styled.hr<{ mdHidden?: boolean; mdVisible?: boolean }>`
  opacity: 0.3;
  border: 0;
  height: 1px;
  width: 100%;
  margin: ${({ theme }) => theme.spacing(2)} 0;

  ${({ theme }) => css`
    background: ${theme.colors.quaternaryGrey};
  `}

  ${({ mdHidden }) => mdHidden && hiddenUp('md')}
  ${({ mdVisible }) => mdVisible && hiddenDown('md')}
`;

export const Pricing = styled(Flex)`
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)} 0;

  ${({ theme }) => theme.media.md.down} {
    justify-content: center;
  }
`;

export const DetailsCardCol = styled(Col)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      padding-top: ${theme.spacing(2)};
    }

    ${theme.media.md.only} {
      grid-column: span 5;
    }
  `}
`;

export const DetailsCard = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      margin-left: 10%;
      max-width: 440px;
    }

    ${theme.media.lg.up} {
      margin-left: 18%;
      max-width: 440px;
    }

    ${theme.media.md.down} {
      text-align: center;
      padding-inline: ${theme.gridContainer.sm};
    }
  `};
`;

export const BreadcrumbsWrapper = styled(Box)<{
  mdHidden?: boolean;
  mdVisible?: boolean;
}>`
  position: relative;
  display: inline-flex;

  ${({ mdHidden, mdVisible, theme }) => css`
    padding: ${theme.spacing(1, 2)};
    z-index: ${theme.zIndex.navigation};

    ${mdHidden && hiddenUp('md')}
    ${mdVisible && hiddenDown('md')}
    
    ${theme.media.md.up} {
      padding: 0 0 ${theme.spacing(1)};
    }
  `};
`;

export const TaxLabel = styled.span`
  color: grey;

  ${({ theme }) => css`
    padding-left: ${theme.spacing(1)};
    font-weight: ${theme.fontWeights.extraLight};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h5};

    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h6};
    }
  `}
`;

export const AffirmSentence = styled.p`
  margin-bottom: 15px;
  min-height: 20px;
`;

export const BoutiquePickUp = styled(Flex)`
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.media.md.up} {
    align-items: center;
    justify-content: flex-start;
  }
`;

export const LearnMore = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;

export const AdditionalCembraMessage = styled(Typography)`
  color: ${({ theme }) => theme.colors.secondaryGrey};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const OneySentence = styled(Flex)`
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  &:hover {
    cursor: pointer;
  }
`;

export const Oney3xBadge = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing(0.2, 0.5)};
`;
